import { z } from 'zod';
import type { ApiSchemaClass, ApiSchemaDefinition } from './types';
import { agentInvokeResponseSchema } from './agent';
import { chatTriggerSourceSchema } from './chat';

export const cocoInvokeBodyV20260601Schema = z.object({
  prompt: z
    .string()
    .describe(
      'User message for Coco. Blocks until the run completes and returns assistant reply text.'
    ),
  systemSuffix: z
    .string()
    .optional()
    .describe('Optional text appended to the Coco system prompt for this run.'),
  model: z
    .string()
    .optional()
    .describe('Optional model override for this run only.'),
  triggerSource: chatTriggerSourceSchema
    .optional()
    .describe(
      'Trigger source recorded on the run. Defaults to "chat-bot" when omitted.'
    ),
});

export type CocoInvokeBody = z.infer<typeof cocoInvokeBodyV20260601Schema>;

export class CocoInvokeV20260601Schema implements ApiSchemaDefinition {
  static readonly version = 'coco-invoke-2026-06-01' as const;

  readonly name = CocoInvokeV20260601Schema.version;
  readonly schema = cocoInvokeBodyV20260601Schema;
  readonly response = agentInvokeResponseSchema;
}

export const COCO_API_SCHEMAS = [
  CocoInvokeV20260601Schema,
] as const satisfies readonly ApiSchemaClass[];
